import React from "react";
import { NavLink } from "react-router-dom"
import { menuText } from "./menuLang";

class StatusKYC extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            UserKYC: this.props.UserKYC ? this.props.UserKYC : false,
            KYCstatus: this.props.UserKYC ? this.props.UserKYC.status : false,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        }
    }

    render() {
        const { KYCstatus } = this.state;
        return(
            <>
            {KYCstatus ? (
                <div className="kyc-status-menu">{menuText.verified[this.state.Language]}</div>
            ) : (
                <NavLink to='/kyc' exact  activeClassName="HeaderAllMainMenuActiveLink" onClick={this.props.ChangeMenu} >
                    <div className="kyc-status-menu">{menuText.not_verified[this.state.Language]}</div>
                </NavLink>
            )}
            </>
        )
    }
}

export default StatusKYC